import Vue from 'vue';
import Router from 'vue-router';

import springFestivalRoutes from './springFestival';
import anniversaryCelebration from './anniversaryCelebration';
import anniversaryRoutes from './anniversary';
import journeyRoutes from './journey';
import answerRoutes from './answer'
import third from './third'
import year from './year'
import aniAppoint from './aniAppoint'
import newVersion from './newVersion'
import recall from './recall'
import maze from './maze'
import mud from './mud'

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: '/tideng',
  routes: [
    ...springFestivalRoutes,
    ...anniversaryCelebration,
    ...anniversaryRoutes,
    ...journeyRoutes,
    ...answerRoutes,
    ...third,
    ...year,
    ...aniAppoint,
    ...newVersion,
    ...recall,
    ...maze,
    ...mud
  ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/tideng/index.js